import gql from 'graphql-tag';

import { CountryFragments } from './fragments/CountryType';
import { FishingWaterFragments } from './fragments/FishingWaterType';
import { PlaceFragments } from './fragments/PlaceType';
import { RegionFragments } from './fragments/RegionType';
import { CatchFragments } from './fragments/CatchType';
import { PostFragments } from './fragments/PostType';
import { ImageFragments } from './fragments/ImageType';
import { UserFragments } from './fragments/UserType';

export const getRegion = gql`
  query GetRegion($id: String!) {
    entry: region(id: $id) {
      ...RegionId
      localName
      country {
        ...CountryId
        countryName
      }
      topFishingWaters(first: 12) {
        edges {
          node {
            ...FishingWaterCarouselItem
          }
        }
      }
      places(first: 12) {
        edges {
          node {
            ...PlaceCarouselItem
          }
        }
      }
    }
  }
  ${CountryFragments.id}
  ${FishingWaterFragments.carouselItem}
  ${PlaceFragments.carouselItem}
  ${RegionFragments.id}
`;

export const getNewRegion = gql`
  query GetNewRegion($id: String!) {
    entry: region(id: $id) {
      ...RegionId
      boundaryLayer {
        boundingBox {
          northEast {
            latitude
            longitude
          }
          southWest {
            latitude
            longitude
          }
        }
      }
      name
      localName
      licenseInfoUrl
      country {
        ...CountryId
        countryName
        topFishingWaters(first: 20) {
          edges {
            node {
              _id: externalId
              displayName
            }
          }
        }
      }
    }
  }
  ${CountryFragments.id}
  ${RegionFragments.id}
`;

export const getRegionPlaces = gql`
  query GetRegionPlaces($id: String!, $first: Int = 20) {
    entry: region(id: $id) {
      ...RegionId
      places(first: $first) {
        edges {
          node {
            ...PlaceId
            name
            slug
          }
        }
      }
    }
  }
  ${PlaceFragments.id}
  ${RegionFragments.id}
`;

export const getRegionTopWaters = gql`
  query GetRegionTopWaters($id: String!, $first: Int = 6) {
    entry: region(id: $id) {
      ...RegionId
      topFishingWaters(first: $first) {
        edges {
          node {
            ...FishingWaterId
            ...FishingWaterLocationFields
            catchesCount
            displayName
            allReviews: reviews {
              totalCount
              totalAverage(attribute: RATING)
            }
            reviews {
              totalCount
              totalAverage(attribute: RATING)
            }
            recentCatches: catches(first: 4, filters: { withPhotos: true, orderByRecent: true }) {
              edges {
                node {
                  ...CatchId
                  post {
                    ...PostId
                    images(first: 1, croppingStrategy: SMART, height: 400, width: 400) {
                      totalCount
                      edges {
                        node {
                          ...ImageFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${CatchFragments.id}
  ${PostFragments.id}
  ${FishingWaterFragments.id}
  ${ImageFragments.imageFields}
  ${FishingWaterFragments.locationFields}
  ${RegionFragments.id}
`;

export const getRegionCatches = gql`
  query GetRegionCatches($id: String!, $first: Int = 10) {
    entry: region(id: $id) {
      ...RegionId
      catches(first: $first, filters: { withPhotos: true, orderByCaughtAt: true }) {
        edges {
          node {
            ...CatchId
            post {
              ...PostId
              catch {
                ...CatchId
                ...CatchFishingWaterName
                ...CatchSpeciesName
                caughtAtGmt
                weight
                length
              }
              createdAt
              displayProductUnits {
                totalCount
              }
              images(first: 1, croppingStrategy: SMART, height: 400, width: 400) {
                totalCount
                edges {
                  node {
                    ...ImageFields
                  }
                }
              }
              user {
                ...UserId
                nickname
              }
            }
          }
        }
      }
    }
  }
  ${CatchFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.id}
  ${ImageFragments.imageFields}
  ${RegionFragments.id}
  ${UserFragments.id}
`;

export const getWatersInRegionBySpecies = gql`
  query GetWatersInRegionBySpecies($id: String!, $speciesId: String) {
    entry: region(id: $id) {
      ...RegionId
      topFishingWaters(first: 12, speciesExternalId: $speciesId) {
        edges {
          node {
            ...FishingWaterId
            displayName
            catchesCount
          }
        }
      }
    }
  }
  ${FishingWaterFragments.id}
  ${RegionFragments.id}
`;

export const getRegionName = gql`
  query GetRegionName($id: String!) {
    region(id: $id) {
      ...RegionId
      name
      localName
      country {
        ...CountryId
        countryName
      }
    }
  }
  ${CountryFragments.id}
  ${RegionFragments.id}
`;
